// Polyfills for WebSocket libraries
(window as any).global = window;
(window as any).process = { env: {} }; 